module.exports = __webpack_public_path__ + "static/media/ET.c7887990.svg";